import { features } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-18 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-600 bg-secondary-100 rounded-full mb-4">
            我们的优势
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 mt-2">为什么数百万瓜友选择吃瓜官网</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="group p-6 bg-background-100 rounded-xl border border-background-200/70 hover:border-primary-200/60 transition-all duration-300"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-50 flex items-center justify-center mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${feature.icon} text-xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}